import dayjs from 'dayjs'

import customParseFormat from 'dayjs/plugin/customParseFormat' // ES 2015

dayjs.extend(customParseFormat)

export { dayjs }
